import React from "react";
import { Link, NavLink } from "react-router-dom";
import { Camera } from "lucide-react";

const linkClass = ({ isActive }) =>
  `font-anton uppercase text-lg tracking-wide px-1 transition-all hover:bg-[#FFD600] ${
    isActive ? "bg-[#FFD600]" : ""
  }`;

export default function Nav() {
  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-40 bg-white border-b-4 border-black"
    >
      <div className="max-w-[1400px] mx-auto px-4 sm:px-8 py-4 flex items-center justify-between">
        <Link
          to="/"
          data-testid="brand-link"
          className="flex items-center gap-2 group"
        >
          <div className="bg-black text-white p-1.5 group-hover:bg-[#FF3B30] transition-colors">
            <Camera size={20} strokeWidth={2.5} />
          </div>
          <span className="font-anton text-2xl uppercase tracking-tight leading-none">
            Srehan<span className="text-[#FF3B30]">.</span>
          </span>
        </Link>

        <nav className="flex items-center gap-3 sm:gap-6">
          <NavLink to="/" end className={linkClass} data-testid="nav-work">
            Work
          </NavLink>
          <NavLink to="/about" className={linkClass} data-testid="nav-about">
            About
          </NavLink>
          <NavLink to="/contact" className={linkClass} data-testid="nav-contact">
            Contact
          </NavLink>
        </nav>
      </div>
    </header>
  );
}
